<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <img
          class="headerimg"
          src="/assets/images/svgs/bannerimgcss.svg"
          alt=""
        />
      </div>
      <div class="col-md-6">
        <h1>Oops <span>:(</span></h1>
        <h2>404</h2>

        <h3>Page not found</h3>
        <p>
          The Page you are looking for doesn't exist or another error occurred.
          Please<span @click="goBack" class="back"> go back</span>, or head over
          to our<router-link to="/"> homepage </router-link>to choose a new
          direction.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
h1 span {
  transform: rotate(90deg);
  display: inline-block;
  margin-left: 20px;
}
div.row {
  padding: 5%;
}
span.back {
  cursor: pointer;
  color: #5e72e4;
}
span.back:hover {
  color: #233dd2;
}
</style>